import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=932468a4&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.vue?vue&type=style&index=0&id=932468a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932468a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('932468a4')) {
      api.createRecord('932468a4', component.options)
    } else {
      api.reload('932468a4', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=932468a4&scoped=true", function () {
      api.rerender('932468a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Loader.vue"
export default component.exports